const mapStateToProps = state => 
({
    step: state.solicitudEmpadronamientoExtranjero.step,
    data: state.solicitudEmpadronamientoExtranjero.data,
    datosCiudadanoTable: state.solicitudEmpadronamientoExtranjero.datosCiudadanoTable,
    datosResidencia: state.solicitudEmpadronamientoExtranjero.datosResidencia,
});

export default mapStateToProps;
